<template>
    <div class="lmy-flash" ref="lmyPresaleBox" style="overflow-x: hidden;">
        <div class="infinite-loading-containers" v-show="!details">
            <i class="loading-defaults"></i>
        </div>
        <div class="lmy-free"  v-show="details">
            <div class="page-back-btn" @click="gobackPage()">
                <i class="iconfont icon-yuyin"></i>
            </div>

        	<div class="free-nav">
                <img :src="details.Img | replaceImgSrc(12)" />
            </div>

            <div class="flash-sum-a">
                <div class="only">
                    <div>
                        <p class="newPrice">￥{{details.SalePrice}}</p>
                        <!-- <p class="oldPrice">市场价￥{{details.MarketPrice}}</p> -->
                    </div>
                    <div v-if="dateIntervene(details.Start)<=0">
                        <span class="on">距结束:</span>
                        <span class="under" v-html="details.clock"></span>
                    </div>
                    <div v-if="dateIntervene(details.Start)>0">
                        <p class="on">距开始:</p>
                        <p class="under" v-html="details.clockStart"></p>
                    </div>
                </div>
                <div class="info">
                    <p class="title">{{details.Name}}</p>
                    <!-- <div class="share-box" style="justify-content: flex-end;height:0.5rem;line-height:0.5rem;">
                        <p class="sell">仅剩{{details.Stock}}份</p>
                        <div @click="goPromote()">
                            <span v-if="details.Rebate&&!routerParam" class="text">赚佣金￥{{details.Rebate}}</span>
                            <span class="text">立即分享</span>
                            <i class="iconfont icon-erweima"></i>
                        </div>
                    </div> -->
                </div>

            </div>

            <div class="free-content">
                <!-- <ul  ref="fixLi" :class="FixedLi?'title fixed-li':'title'" >
                    <li :class="isItemActive=='item1'?'active':''" @click="scopeToPosition('item1')">抢购须知</li>
                    <li :class="isItemActive=='item2'?'active':''" @click="scopeToPosition('item2')">产品内容</li>
                    <li :class="isItemActive=='item3'?'active':''" @click="scopeToPosition('item3')">温馨提示</li>
                    <li :class="isItemActive=='item4'?'active':''" @click="scopeToPosition('item4')">图文详情</li>
                </ul> -->

                <div class="lmy-pur-content" ref="item1">
                    <div class="content-head">抢购须知</div>
                    <div class="presale-limitDate">
                        <p>【使用期限】: {{details.UseTimeFrom|dateToYMD}}-{{details.UseTimeTo|dateToYMD}}</p>
                    </div>
                    <div class="content-body" v-html="details.PurchaseNotes"></div>
                </div>

                <div class="lmy-pur-content" ref="item2">
                    <div class="content-head">产品内容</div>
                    <div class="content-body" v-html="details.ProductContains"></div>
                </div>

                <div class="lmy-pur-content" ref="item3">
                    <div class="content-head">温馨提示</div>
                    <div class="content-body" v-html="details.Tips"></div>
                </div>

                <!-- <div class="lmy-pur-content" ref="item4">
                    <div class="content-head">图文详情</div>
                    <div class="content-body" v-html="details.Details">
                    </div>
                </div> -->
            </div>
            <!-- <div class="share-float" v-if="details.Rebate && !routerParam" @click="goPromote()">
                <p class="s-title">会员分享</p>
                <p class="s-price">返￥{{details.Rebate}}</p>
                <p class="s-tip">下单即得佣金</p>
                <p class="s-btn">立即分享</p>
            </div> -->
            <div class="order-btn" v-if="details.Token">
                <div class="price-box">应付：<label class="price">¥ <span class="num">{{details.SalePrice}}</span></label></div>
                <!-- <div class="submit-btn" @click="toBook()" style="line-height: normal;" v-if="details.Rebate&&!routerParam">
                    <p style="margin-top: 0.04rem;">去支付</p>
                    <p style="font-size: .2rem;text-align: center;">立返￥{{details.Rebate}}</p>
                </div> -->
                <div class="submit-btn" @click="toBook()" >
                    <p >去支付</p>
                </div>
            </div>
            <div class="order-btn" v-else>
                <div class="price-box" v-if="details.SalePrice">价格：<label class="price">¥ <span class="num">{{details.SalePrice}}</span></label></div>
                <div class="submit-btn" style="color: #fff; background: #bbb;">
                    <p >无法预定</p>
                </div>
            </div>

        </div>
        <Promote v-if="isPromoteShow" @close="isPromoteShow=false" :details="details" ></Promote>
    </div>


</template>
<script>
    import Promote from './promote.vue';

	export default{
		name:'activity-details',
        components:{
            Promote
        },
		data(){
			return{
				time:'',
                FixedLi:false,
                backShow:true,
                details:'',
                clock:'',
                isItemActive:'item1',
                isPromoteShow:false,
                fromPath:'',
                routerParam:''
			}
        },
        beforeRouteEnter: (to, from, next) => {

                next(vm=>{
                    vm.fromPath=from.path
                })

        },
		methods:{
            goPromote(){
                var userInfo=this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'';
                if(userInfo.CustomerNO){
                    this.$router.push({ path:'/presalePromote?id='+this.$route.query.id+'&rebate='+this.details.Rebate});
                }else{
                    this.$router.push({ path: '/login'});
                }
            },
            gobackPage(){

                if(this.fromPath=='/'||this.fromPath==''){
                    this.routetokPage('/')
                }else{
                    window.history.go(-1)
                }

            },
            timeLoop(details,start,end){

                var num=1;
                var that=this;
                var end=that.dateIntervene(end);
                var start=that.dateIntervene(start);
                var time=setInterval(function(){
                    num++;
                    if(num>=end){
                        clearInterval(time);
                    }else{
                        that.$nextTick(function () {
                            that.$set(details,'clock',that.betDateFomate(end-num));
                            that.$set(details,'clockStart',that.betDateFomate(start-num));
                        });
                    }
                },1000)
            },
            // dateIntervene(date){
            //     var s1=new Date().getTime();
            //     var s2=new Date(date).getTime();
            //     return parseInt(((s2-s1>0)?(s2-s1):0)/1000);
            // },
            betDateFomate(time){
                var d,h,m,s;
                if (time>=0) {
                    d = Math.floor(time/60/60/24);
                    h = Math.floor(time/60/60%24);
                    m = Math.floor(time/60%60);
                    s = Math.floor(time%60);
                }
                var intv='<span>'+d+'</span> 天 <span>'+(h<10?'0'+h:h)+'</span> 小时 <span>'+(m<10?'0'+m:m)+'</span> 分 <span>'+(s<10?'0'+s:s)+'</span> 秒 ';
                return intv;
            },
            dateIntervene(date){
                var s1=new Date().getTime();
                var s2=new Date(date).getTime();
                return parseInt(((s2-s1>0)?(s2-s1):0)/1000);
            },
            initData(){
                var that=this;

                var params={
                    id:this.$route.query.id,
                    t:new Date().valueOf()
                }

                that.getRequest({
                    url: that.Api.getPreSaleDetails,
                    params: params
                }).then(res => {

                    if (res&&res.IsSuccess) {


                        that.details=res.Result;
                        //配置分享
                        var option=res.Result.ShareInfo;
                        that.setConfigShare(option);
                        that.dao.set('presaleDetails',JSON.stringify(that.details))
                        that.timeLoop(that.details, that.details.Start, that.details.End);
                        //设置标题行的随屏滚动位置监听
                        // that.initWindowScrollEventListener();
                    } else {
                        that.details=''
                    }

                });
            },
            //点击滚动到相应位置
            scopeToPosition(name) {

                if (!name) return;
                this.isItemActive = name;
                var height = this.$refs[name].offsetTop;
                var H = this.$refs['fixLi'].offsetHeight;

                document.documentElement.scrollTop = height-H;
                window.pageYOffset = height-H;
                document.body.scrollTop = height-H;
            },
            // 设置标题行的随屏滚动位置监听
            initWindowScrollEventListener() {

                var that = this;
                var windowSrollTop=0;//屏幕滚动高度
                var fixLiHeight=0;//标题栏的高度位置

                var itemActive=0;//屏幕滚动高度触发的焦点，默认item1
                var elementList ='';
                var titleHeight='';
                window.addEventListener('touchstart', touchScroll);
                window.addEventListener('touchmove',touchScroll);
                window.addEventListener('touchend',touchScroll);
                window.addEventListener('scroll',touchScroll);

                function touchScroll(){
                  if(that.$refs['lmyPresaleBox']) {

                    windowSrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
                    fixLiHeight = fixLiHeight || that.$refs['fixLi'].offsetTop;
                    titleHeight = document.querySelector('.content-head-a').offsetHeight + 2;

                    elementList = document.querySelectorAll('.lmy-pur-content');

                    that.FixedLi = (windowSrollTop > fixLiHeight) ? true : false;
                    that.backShow = (windowSrollTop > fixLiHeight - 50) ? false : true;

                    itemActive = 0;
                    elementList.forEach((item, index) => {
                      itemActive = (windowSrollTop > (item.offsetTop - titleHeight)) ? (itemActive + 1) : itemActive;
                    })
                    that.isItemActive = 'item' + (itemActive || 1);
                  }
                }
            } ,
            IsLogIn() {
                var that=this;
                that.getRequest({
                  url: that.Api.checkLogIn,
                }).then(res => {
                  if (res.IsSuccess) {
                    if (that.routerParam){
                      this.$router.push({
                        path: '/presaleBook',
                        query: {
                          provenience: 'Hotel818'
                        }
                      })
                    }else {
                      this.$router.push('/presaleBook')
                    }
                  } else {
                    this.$router.push({ path: '/login'})
                    console.log(1)
                  }
                });
            },

            toBook(){
                this.IsLogIn()
                // this.$router.push('/presaleBook')

            },

		},
		mounted(){
		  this.initData();
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/activity/details.vue